import apiClient from '../client.js'

export const productsAPI = {
  // Public product endpoints
  async getProducts(params = {}) {
    const response = await apiClient.get('/products', { params })
    return response.data
  },

  async getProduct(slug) {
    const response = await apiClient.get(`/products/${slug}`)
    return response.data
  },

  async getRelatedProducts(slug, params = {}) {
    const response = await apiClient.get(`/products/${slug}/related`, { params })
    return response.data
  },

  async getBulkDiscount(productId) {
    const response = await apiClient.get(`/products/${productId}/bulk-discount`)
    return response.data
  },

  async getProductWithCustomPricing(productId, params = {}) {
    const response = await apiClient.get(`/products/${productId}/pricing`, { params })
    return response.data
  },

  async getAllProducts(params = {}) {
    const response = await apiClient.get('/admin/products', { params })
    return response.data
  },

  async searchProducts(params = {}) {
    const response = await apiClient.get('/products/search', { params })
    return response.data
  },

  // Admin product endpoints
  async getAdminProducts(params = {}) {
    const response = await apiClient.get('/admin/products', { params })
    return response.data
  },

  async createProduct(productData) {
    const response = await apiClient.post('/admin/products', productData)
    return response.data
  },

  async getAdminProduct(productId) {
    const response = await apiClient.get(`/admin/products/${productId}`)
    return response.data
  },

  async updateProduct(productId, productData) {
    const response = await apiClient.put(`/admin/products/${productId}`, productData)
    return response.data
  },

  async deleteProduct(productId) {
    const response = await apiClient.delete(`/admin/products/${productId}`)
    return response.data
  },

  async toggleProductActive(productId) {
    const response = await apiClient.patch(`/admin/products/${productId}/toggle-active`)
    return response.data
  },

  async toggleProductSale(productId) {
    const response = await apiClient.patch(`/admin/products/${productId}/toggle-sale`)
    return response.data
  },

  async updateStock(productId, stockData) {
    const response = await apiClient.put(`/admin/products/${productId}/stock`, stockData)
    return response.data
  },

  async duplicateProduct(productId) {
    const response = await apiClient.post(`/admin/products/${productId}/duplicate`)
    return response.data
  },

  // Product statistics
  async getProductStats() {
    const response = await apiClient.get('/admin/products/stats')
    return response.data
  },

  // Product variants
  async getProductVariants(slug) {
    const response = await apiClient.get(`/products/${slug}/variants`)
    return response.data
  },

  async getAdminProductVariants(productId) {
    const response = await apiClient.get(`/admin/products/${productId}/variants`)
    return response.data
  },

  async updateProductVariants(productId, variantIds) {
    const response = await apiClient.put(`/admin/products/${productId}/variants`, {
      variant_ids: variantIds
    })
    return response.data
  },

  async clearProductReservations(productId) {
    const response = await apiClient.delete(`/admin/products/${productId}/clear-reservations`)
    return response.data
  },

  async getRecommendedProducts(slug) {
    const response = await apiClient.get(`/products/${slug}/recommended`)
    return response.data
  },

  async getProductSets(slug) {
    const response = await apiClient.get(`/products/${slug}/sets`)
    return response.data
  },

  async getAdminProductRecommended(productId) {
    const response = await apiClient.get(`/admin/products/${productId}/recommended`)
    return response.data
  },

  async updateProductRecommended(productId, recommendedIds) {
    const response = await apiClient.put(`/admin/products/${productId}/recommended`, {
      recommended_ids: recommendedIds
    })
    return response.data
  }
}
